import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';
@Pipe({
    name: 'bulkFileUploadedUrl',
})
export class BulkFileUploadedUrl implements PipeTransform {
    transform(value: any, level): string {
        const url = value.split('/');
        if (url.length <= 2) {
            return level?.data?.workSpaceFodlerName ? level?.data?.workSpaceFodlerName : '-';
        } else {
            if (url.length == 3) {
                return url[1];
            } else {
                let formateString = "";
                for (let index = 3; index < url.length; index++) {
                    formateString = formateString + "/.."
                }
                formateString = formateString + "/"
                return url[1] + formateString + url[url.length - 2];

            }
        }

    }

}


